export default __webpack_public_path__ + "static/media/search.b6887109.svg";